import { Utils } from '../../../_helpers/utilities';
import { ChartData, ChartSelection } from './chart.interface';
import { ChartTypes } from './chart.structs';
import { EventEmitter } from '@angular/core';
import { utradePlusTheme } from '../../../../_vendors/themes/lynk.theme';

export class ChartTemplate {
    changeEmitter = new EventEmitter();

    chartSelection: ChartSelection = {
        high: '',
        low: '',
        open: '',
        close: '',
        volume: '',
        line: ''
    };

    volumeSeries =
        {
            name: 'Volume',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            itemStyle: {
                normal: {} // PlaceHolder For dynamic color
            },
            markLine: {
                symbol: 'none',
                itemStyle: {
                    normal: {
                        color: '#1e90ff',
                        label: {
                            show: false
                        }
                    }
                },
                data: [
                    { type: 'average', name: 'Average Value' }
                ]
            },
            barWidth: '50%',
            maxWidth: '50%',
            data: []// this.chartData.volumeData
        };


    options = {
        animation: true,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: `rgba(${Utils.rgbToHex(utradePlusTheme.A100).rgb}, 0.88)`,
                    color: utradePlusTheme.contrast['600']
                }
            },
            formatter: (params) => {
                // tslint:disable-next-line:prefer-for-of
                for (let i = 0; i < params.length; i++) {
                    if (params[i].seriesName === 'Volume') {
                        this.chartSelection.volume = params[i].value;
                    } else if (params[i].seriesName === 'Candle Stick' || params[i].seriesName === 'OHLC') {
                        this.chartSelection.high = params[i].value[4];
                        this.chartSelection.low = params[i].value[3];
                        this.chartSelection.open = params[i].value[1];
                        this.chartSelection.close = params[i].value[2];
                    } else if (params[i].seriesName === 'area' || params[i].seriesName === 'Close Data') {
                        this.chartSelection.line = params[i].data;
                    }
                }
                this.changeEmitter.emit();
                return null;
            },
        },
        backgroundColor: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 1,
            colorStops: [
                {
                    offset: 0,
                    color: `rgba(${Utils.rgbToHex(utradePlusTheme.A100).rgb}, 0.5)`,
                },
                {
                    offset: 1,
                    color: `rgba(${Utils.rgbToHex(utradePlusTheme['50']).rgb}, 0.8)`,
                }
            ],
            globalCoord: false
        },
        axisPointer: {
            link: [
                {
                    xAxisIndex: [0, 1]
                }
            ]
        },
        dataZoom: [
            {
                type: 'inside',
                xAxisIndex: [0, 1],
                start: 80,
                end: 100,
                top: 30,
                height: 20
            }
        ],
        xAxis: [
            {
                show: false,
                type: 'category',
                data: [], // this.chartData.xAxis,
                boundaryGap: true,
                min: 'dataMin',
                max: 'dataMax',
                axisPointer: {
                    show: true
                }
            },
            {
                type: 'category',
                gridIndex: 1,
                data: [], // this.chartData.xAxis,
                scale: true,
                boundaryGap: true,
                splitNumber: 20,
                min: 'dataMin',
                max: 'dataMax',
                axisLabel: {
                    formatter: (value) => {
                        const dateObj = new Date(value);
                        let dateValue = (dateObj.getHours().toString().length < 2 ? '0' : '') + dateObj.getHours().toString();
                        dateValue += ':';
                        dateValue += (dateObj.getMinutes().toString().length < 2 ? '0' : '') + dateObj.getMinutes().toString();
                        return dateValue;
                    }
                },
                axisPointer: {
                    type: 'none',
                    label: { show: false },
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                position: 'right',
                boundaryGap: [0.01, 0.01],
                scale: true,
                nameLocations: 'end',
                splitNumber: 2,
                axisLine: { show: false },
                splitLine: { show: true },
                axisTick: { show: false },
                axisLabel: {
                    inside: false,
                    formatter: '{value}\n',
                    align: 'left'
                },
                min: 'dataMin'
            }, {
                scale: true,
                gridIndex: 1,
                splitNumber: 2,
                axisLabel: { show: false },
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { show: false },
                min: 'dataMin'
            }
        ],
        grid: [
            {
                left: 20,
                right: 70,
                top: '10%',
                height: '70%'
            }, {
                left: 20,
                right: 70,
                height: '20%',
                bottom: 25
            }
        ],
        series: []
    };

    constructor(chartData: ChartData, chartType: ChartTypes) {
        let secondChart = null;

        this.options.xAxis[0].data = chartData.xAxis;
        this.options.xAxis[1].data = chartData.xAxis;

        this.volumeSeries.itemStyle.normal = {
            color: (params) => {
                const currVolBar = chartData.data[params.dataIndex];
                const lastDiff = parseFloat(currVolBar[1]) - parseFloat(currVolBar[0]);
                if (lastDiff > 0) {
                    return utradePlusTheme.profit;
                } else {
                    return utradePlusTheme.loss;
                }
            }
        };
        this.volumeSeries.data = chartData.volumeData;


        if (chartType === ChartTypes.candle) {
            secondChart = {
                type: 'candlestick',
                name: 'Candle Stick',
                data: chartData.data,
                itemStyle: {
                    normal: {
                        color: utradePlusTheme.profit,
                        color0: utradePlusTheme.loss,
                        borderColor: utradePlusTheme.profit,
                        borderColor0: utradePlusTheme.loss
                    }
                },
                animationDelay: 100
            };
        } else if (chartType === ChartTypes.line) {
            secondChart = {
                type: 'line',
                name: 'Close Data',
                data: chartData.allCloses,
                smooth: true
            };
        } else if (chartType === ChartTypes.area) {
            secondChart = {
                type: 'line',
                name: 'area',
                data: chartData.allCloses,
                sampling: 'average',
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: `rgba(${Utils.rgbToHex(utradePlusTheme.loss).rgb}, 0.33)` // color at 0% position
                        }, {
                            offset: 1, color: `rgba(${Utils.rgbToHex(utradePlusTheme.loss).rgb}, 0.73)` // color at 100% position
                        }],
                        globalCoord: false // false by default
                    }
                    // opacity: 0.33
                }
            };
        } else {
            secondChart = {
                name: 'OHLC',
                type: 'custom',
                renderItem,
                dimensions: [null, 'open', 'close', 'lowest', 'highest'],
                encode: {
                    x: 0,
                    y: [1, 2, 3, 4],
                    tooltip: [1, 2, 3, 4]
                },
                data: chartData.ohlc
            };
        }

        this.options.series = [
            this.volumeSeries,
            secondChart
        ];

    }
}

function renderItem(params, api) {
    const xValue = api.value(0);
    const openPoint = api.coord([xValue, api.value(1)]);
    const closePoint = api.coord([xValue, api.value(2)]);
    const lowPoint = api.coord([xValue, api.value(3)]);
    const highPoint = api.coord([xValue, api.value(4)]);
    const halfWidth = api.size([1, 0])[0] * 0.35;
    const style = api.style({
        stroke: api.visual('color')
    });

    return {
        type: 'group',
        children: [{
            type: 'line',
            shape: {
                x1: lowPoint[0], y1: lowPoint[1],
                x2: highPoint[0], y2: highPoint[1]
            },
            style
        }, {
            type: 'line',
            shape: {
                x1: openPoint[0], y1: openPoint[1],
                x2: openPoint[0] - halfWidth, y2: openPoint[1]
            },
            style
        }, {
            type: 'line',
            shape: {
                x1: closePoint[0], y1: closePoint[1],
                x2: closePoint[0] + halfWidth, y2: closePoint[1]
            },
            style
        }]
    };

}
